import { useEffect, useRef } from 'react';

const FOCUSABLE =
  'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

// Prende o foco dentro do container quando `active=true`. Move o foco pro
// primeiro focusable ao ativar e restaura pro elemento anterior ao desativar.
// Usado em Modal e Drawer.
export function useFocusTrap(active) {
  const containerRef = useRef(null);
  const lastFocusedRef = useRef(null);

  useEffect(() => {
    if (!active) return undefined;
    lastFocusedRef.current = document.activeElement;

    const container = containerRef.current;
    if (!container) return undefined;

    // Primeiro focusable (se houver), senão foca o próprio container.
    const focusables = () => container.querySelectorAll(FOCUSABLE);
    const first = focusables()[0];
    (first || container).focus?.();

    const handleKey = (e) => {
      if (e.key !== 'Tab') return;
      const nodes = Array.from(focusables());
      if (nodes.length === 0) {
        e.preventDefault();
        return;
      }
      const firstNode = nodes[0];
      const lastNode = nodes[nodes.length - 1];
      if (e.shiftKey && document.activeElement === firstNode) {
        e.preventDefault();
        lastNode.focus();
      } else if (!e.shiftKey && document.activeElement === lastNode) {
        e.preventDefault();
        firstNode.focus();
      }
    };

    container.addEventListener('keydown', handleKey);
    return () => {
      container.removeEventListener('keydown', handleKey);
      try {
        lastFocusedRef.current?.focus?.();
      } catch {
        /* elemento pode ter desmontado — noop */
      }
    };
  }, [active]);

  return containerRef;
}

export default useFocusTrap;
